import React, { useState } from 'react';
import { PlayingCard } from './PlayingCard';
const suits = [{
  symbol: '♠',
  name: '黑桃',
  english: 'Spades',
  color: '#1a1a2e',
  textColor: '#e8d5ff',
  desc: '黑色，形状像铲子'
}, {
  symbol: '♥',
  name: '红心',
  english: 'Hearts',
  color: '#cc2222',
  textColor: '#ffcccc',
  desc: '红色，形状像心形'
}, {
  symbol: '♦',
  name: '方块',
  english: 'Diamonds',
  color: '#cc2222',
  textColor: '#ffcccc',
  desc: '红色，形状像菱形'
}, {
  symbol: '♣',
  name: '梅花',
  english: 'Clubs',
  color: '#1a1a2e',
  textColor: '#e8d5ff',
  desc: '黑色，形状像三叶草'
}];
const ranks = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
const rankValues: Record<string, {
  chip: number;
  desc: string;
}> = {
  A: {
    chip: 11,
    desc: '王牌，价值最高'
  },
  '2': {
    chip: 2,
    desc: '最小的数字牌'
  },
  '3': {
    chip: 3,
    desc: ''
  },
  '4': {
    chip: 4,
    desc: ''
  },
  '5': {
    chip: 5,
    desc: ''
  },
  '6': {
    chip: 6,
    desc: ''
  },
  '7': {
    chip: 7,
    desc: ''
  },
  '8': {
    chip: 8,
    desc: ''
  },
  '9': {
    chip: 9,
    desc: ''
  },
  '10': {
    chip: 10,
    desc: ''
  },
  J: {
    chip: 10,
    desc: '杰克 Jack'
  },
  Q: {
    chip: 10,
    desc: '皇后 Queen'
  },
  K: {
    chip: 10,
    desc: '国王 King'
  }
};
export function BasicCards() {
  const [selectedSuit, setSelectedSuit] = useState<string | null>(null);
  const [selectedRank, setSelectedRank] = useState<string | null>(null);
  const [hoveredRank, setHoveredRank] = useState<string | null>(null);
  return <div className="space-y-10" data-id="element-6">
      {/* Suits Section */}
      <div data-id="element-7">
        <h3 className="text-xl font-bold mb-2" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-8">
          🃏 四种花色
        </h3>
        <p className="text-sm mb-6" style={{
        color: '#b090d0'
      }} data-id="element-9">
          扑克牌有四种花色（suit），每种花色有13张牌，共52张。点击花色了解详情：
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-10">
          {suits.map(suit => <button key={suit.symbol} onClick={() => setSelectedSuit(selectedSuit === suit.symbol ? null : suit.symbol)} className="panel p-4 text-center transition-all duration-300 hover:scale-105" style={{
          border: selectedSuit === suit.symbol ? `2px solid ${suit.color === '#cc2222' ? '#ff6666' : '#8888ff'}` : undefined,
          boxShadow: selectedSuit === suit.symbol ? `0 0 20px ${suit.color === '#cc2222' ? 'rgba(255,100,100,0.3)' : 'rgba(100,100,255,0.3)'}` : undefined
        }} data-id="element-11">
              <div style={{
            fontSize: 48,
            color: suit.color === '#cc2222' ? '#cc2222' : '#e8d5ff',
            lineHeight: 1,
            marginBottom: 8
          }} data-id="element-12">
                {suit.symbol}
              </div>
              <div className="font-bold text-lg" style={{
            color: suit.textColor,
            fontFamily: 'Cinzel, serif'
          }} data-id="element-13">
                {suit.name}
              </div>
              <div className="text-xs mt-1" style={{
            color: '#9080b0'
          }} data-id="element-14">
                {suit.english}
              </div>
              {selectedSuit === suit.symbol && <div className="mt-3 text-xs p-2 rounded" style={{
            background: 'rgba(0,0,0,0.3)',
            color: '#d0b0ff'
          }} data-id="element-15">
                  {suit.desc}
                </div>}
            </button>)}
        </div>

        {/* Show all 13 cards of selected suit */}
        {selectedSuit && <div className="mt-6 panel p-4" data-id="element-16">
            <p className="text-sm mb-4" style={{
          color: '#b090d0'
        }} data-id="element-17">
              {suits.find(s => s.symbol === selectedSuit)?.name}{' '}
              的全部13张牌：
            </p>
            <div className="flex flex-wrap gap-2 justify-center" data-id="element-18">
              {ranks.map(rank => <PlayingCard key={rank} rank={rank} suit={selectedSuit} size="sm" data-id="element-19" />)}
            </div>
          </div>}
      </div>

      <div className="section-divider" data-id="element-20" />

      {/* Ranks Section */}
      <div data-id="element-21">
        <h3 className="text-xl font-bold mb-2" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-22">
          🔢 牌面点数
        </h3>
        <p className="text-sm mb-6" style={{
        color: '#b090d0'
      }} data-id="element-23">
          每张牌都有一个点数（rank）。在小丑牌中，点数决定了这张牌能贡献多少
          <span style={{
          color: '#4fc3f7'
        }} data-id="element-24">
            筹码（Chips）
          </span>
          。 点击任意牌查看详情：
        </p>

        <div className="flex flex-wrap gap-3 justify-center mb-6" data-id="element-25">
          {ranks.map(rank => <div key={rank} onMouseEnter={() => setHoveredRank(rank)} onMouseLeave={() => setHoveredRank(null)} onClick={() => setSelectedRank(selectedRank === rank ? null : rank)} data-id="element-26">
              <PlayingCard rank={rank} suit="♠" size="sm" selected={selectedRank === rank} highlighted={hoveredRank === rank && selectedRank !== rank} data-id="element-27" />
            </div>)}
        </div>

        {/* Rank info panel */}
        {selectedRank && <div className="panel p-4 animate-score-pop" data-id="element-28">
            <div className="flex items-center gap-4 flex-wrap" data-id="element-29">
              <PlayingCard rank={selectedRank} suit="♥" size="md" data-id="element-30" />
              <PlayingCard rank={selectedRank} suit="♠" size="md" data-id="element-31" />
              <div className="flex-1 min-w-48" data-id="element-32">
                <div className="text-xl font-bold mb-2" style={{
              color: '#FFD700',
              fontFamily: 'Cinzel, serif'
            }} data-id="element-33">
                  {selectedRank === 'J' ? 'J（杰克 Jack）' : selectedRank === 'Q' ? 'Q（皇后 Queen）' : selectedRank === 'K' ? 'K（国王 King）' : selectedRank === 'A' ? 'A（王牌 Ace）' : `数字 ${selectedRank}`}
                </div>
                <div className="flex items-center gap-3 mb-2" data-id="element-34">
                  <span className="text-sm" style={{
                color: '#b090d0'
              }} data-id="element-35">
                    筹码贡献：
                  </span>
                  <span className="chip-badge px-3 py-1 rounded-full text-sm number-mono" data-id="element-36">
                    +{rankValues[selectedRank].chip} Chips
                  </span>
                </div>
                {rankValues[selectedRank].desc && <p className="text-sm" style={{
              color: '#9080b0'
            }} data-id="element-37">
                    {rankValues[selectedRank].desc}
                  </p>}
                {['J', 'Q', 'K', '10'].includes(selectedRank) && <p className="text-xs mt-2 p-2 rounded" style={{
              background: 'rgba(255,215,0,0.05)',
              color: '#c0a060',
              border: '1px solid rgba(255,215,0,0.2)'
            }} data-id="element-38">
                    💡 10、J、Q、K 的筹码值都是 10
                  </p>}
              </div>
            </div>
          </div>}

        {/* Chip value table */}
        <div className="mt-6 panel p-4" data-id="element-39">
          <h4 className="text-sm font-bold mb-3" style={{
          color: '#FFD700',
          fontFamily: 'Cinzel, serif'
        }} data-id="element-40">
            筹码值速查表
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-id="element-41">
            {ranks.map(rank => <div key={rank} className="flex items-center justify-between p-2 rounded" style={{
            background: 'rgba(0,0,0,0.3)',
            border: '1px solid rgba(255,215,0,0.1)'
          }} data-id="element-42">
                <span className="font-bold" style={{
              color: '#e8d5ff',
              fontFamily: 'Courier Prime, monospace',
              minWidth: 24
            }} data-id="element-43">
                  {rank}
                </span>
                <span className="text-xs" style={{
              color: '#9080b0'
            }} data-id="element-44">
                  {rank === 'J' ? 'Jack' : rank === 'Q' ? 'Queen' : rank === 'K' ? 'King' : rank === 'A' ? 'Ace' : ''}
                </span>
                <span className="chip-badge px-2 py-0.5 rounded text-xs number-mono" data-id="element-45">
                  {rankValues[rank].chip}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      <div className="section-divider" data-id="element-46" />

      {/* Full deck visualization */}
      <div data-id="element-47">
        <h3 className="text-xl font-bold mb-2" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-48">
          🎴 完整牌组
        </h3>
        <p className="text-sm mb-4" style={{
        color: '#b090d0'
      }} data-id="element-49">
          标准扑克牌组共有{' '}
          <span style={{
          color: '#FFD700'
        }} data-id="element-50">
            52张牌
          </span>{' '}
          = 4种花色 × 13个点数
        </p>
        <div className="space-y-3" data-id="element-51">
          {suits.map(suit => <div key={suit.symbol} className="flex items-center gap-2 flex-wrap" data-id="element-52">
              <span className="text-2xl w-8 flex-shrink-0" style={{
            color: suit.color === '#cc2222' ? '#cc2222' : '#e8d5ff'
          }} data-id="element-53">
                {suit.symbol}
              </span>
              <div className="flex gap-1 flex-wrap" data-id="element-54">
                {ranks.map(rank => <PlayingCard key={rank} rank={rank} suit={suit.symbol} size="xs" data-id="element-55" />)}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}